import React from "react";
import { FiActivity, FiCast, FiMap } from "react-icons/fi";
import { Link } from "react-router-dom";
import ScrollAnimation from "react-animate-on-scroll";

const ServiceList = [
  {
    Image: <FiActivity />,
    title: "Avoid lawsuits",
    description:
      "Stay legally compliant by meeting accessibility standards, reducing the risk of penalties and legal actions.",
  },
  {
    Image: <FiCast />,
    title: "Improve brand reputation.",
    description:
      "Demonstrate inclusivity and social responsibility, which builds trust and enhances your brand image.",
  },
  {
    Image: <FiMap />,
    title: "Ensure access for everyone.",
    description:
      "Create an inclusive online experience, allowing all users, including those with disabilities, to interact with your website seamlessly.",
  },
];

const ServiceOne = ({ textAlign, serviceStyle }) => {
  return (
    <div className="row row--15 service-wrapper mt--30">
      {ServiceList.map((val) => (
        <div className="col-lg-4 col-md-6 col-sm-6 col-12" key={val.title}>
          <ScrollAnimation
            animateIn="fadeInUp"
            animateOut="fadeInOut"
            animateOnce={true}
          >
            <div className={`service ${serviceStyle} ${textAlign}`}>
              <div className="icon">{val.Image}</div>
              <div className="content">
                <h4 className="title w-600">
                  <Link
                    to="#service"
                    dangerouslySetInnerHTML={{ __html: val.title }}
                  ></Link>
                </h4>
                <p
                  className="description b1 color-gray mb--0"
                  dangerouslySetInnerHTML={{ __html: val.description }}
                ></p>
              </div>
            </div>
          </ScrollAnimation>
        </div>
      ))}
    </div>
  );
};
export default ServiceOne;
